import { axios } from '../../../utilities/axiosClient'

/**
 * メールアドレス変更の完了API
 * ユーザーがメールアドレスに添付されたURLをクリックすると発火する
 */

export const getSettingEmailComplete = (token: string) =>
  axios.get(`/api/mail_edit/complete/${token}`)
